
              import "_sentry-debug-id-injection-stub";
              import * as OriginalModule from "./js/loader.js";
              export default OriginalModule.default;
              export * from "./js/loader.js";